import React, { useState } from 'react';
import Modal from '../../../../../components/common/Modal';

const AddExamModal = ({ isOpen, onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    title: '',
    course: '',
    duration: '',
    totalScore: '',
    status: 'active',
    description: '',
    instructions: '',
    skippable: false,
  });

  const [errors, setErrors] = useState({});

  // قائمة الدورات الوهمية
  const mockCourses = [
    { id: 1, title: 'مبادئ البرمجة بلغة Python' },
    { id: 2, title: 'تطوير تطبيقات الويب' },
    { id: 3, title: 'قواعد البيانات SQL' },
    { id: 4, title: 'تصميم واجهات المستخدم' },
    { id: 5, title: 'الأمن السيبراني' },
    { id: 6, title: 'الذكاء الاصطناعي' },
    { id: 7, title: 'تطوير تطبيقات الموبايل' }
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title.trim()) newErrors.title = 'عنوان الاختبار مطلوب';
    if (!formData.course.trim()) newErrors.course = 'اختيار الدورة مطلوب';
    if (!formData.duration || formData.duration <= 0) newErrors.duration = 'مدة الاختبار يجب أن تكون أكبر من 0';
    if (!formData.totalScore || formData.totalScore <= 0) newErrors.totalScore = 'الدرجة الكاملة يجب أن تكون أكبر من 0';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      await onAdd(formData);
      onClose();
    } catch (error) {
      // Handle error
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSkippableChange = () => {
    setFormData(prev => ({ ...prev, skippable: !prev.skippable }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="إضافة اختبار جديد"
      size="2xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* عنوان الاختبار */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            عنوان الاختبار
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
              errors.title ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.title && (
            <p className="mt-1 text-sm text-red-500">{errors.title}</p>
          )}
        </div>

        {/* اختيار الدورة */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            الدورة
          </label>
          <select
            name="course"
            value={formData.course}
            onChange={handleChange}
            className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
              errors.course ? 'border-red-500' : 'border-gray-300'
            }`}
          >
            <option value="">اختر الدورة</option>
            {mockCourses.map((course) => (
              <option key={course.id} value={course.title}>
                {course.title}
              </option>
            ))}
          </select>
          {errors.course && (
            <p className="mt-1 text-sm text-red-500">{errors.course}</p>
          )}
        </div>

        {/* مدة الاختبار والدرجة الكاملة */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              مدة الاختبار (بالدقائق)
            </label>
            <input
              type="number"
              name="duration"
              value={formData.duration}
              onChange={handleChange}
              className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
                dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                errors.duration ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.duration && (
              <p className="mt-1 text-sm text-red-500">{errors.duration}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              الدرجة الكاملة
            </label>
            <input
              type="number"
              name="totalScore"
              value={formData.totalScore}
              onChange={handleChange}
              className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
                dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                errors.totalScore ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.totalScore && (
              <p className="mt-1 text-sm text-red-500">{errors.totalScore}</p>
            )}
          </div>
        </div>

        {/* وصف الاختبار */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            وصف الاختبار
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
        </div>

        {/* تعليمات الاختبار */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            تعليمات الاختبار
          </label>
          <textarea
            name="instructions"
            value={formData.instructions}
            onChange={handleChange}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
              dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
        </div>

        {/* خيارات إضافية */}
        <div className="flex items-center">
          <input
            type="checkbox"
            id="skippable"
            name="skippable"
            checked={formData.skippable}
            onChange={handleSkippableChange}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label htmlFor="skippable" className="mr-2 block text-sm text-gray-700 dark:text-gray-300">
            السماح بتخطي الأسئلة
          </label>
        </div>

        {/* أزرار التحكم */}
        <div className="flex justify-end space-x-2 rtl:space-x-reverse">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg 
              hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600"
          >
            إلغاء
          </button>
          <button
            type="submit"
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg 
              hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
              dark:bg-blue-500 dark:hover:bg-blue-600"
          >
            إضافة
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddExamModal;
